import { Button } from '@/components/ui/button';
import { Home } from 'lucide-react';
import { Link } from 'react-router';

export const NotFoundPage = () => {
  return (
    <div className='container flex flex-col items-center justify-center min-h-[80vh] text-center px-4'>
      <h1 className='text-4xl font-bold mb-4 bg-clip-text text-transparent bg-gradient-to-r from-primary to-primary/60'>
        Oops! Page Not Found
      </h1>

      <p className='text-lg text-muted-foreground mb-6 max-w-md'>
        Looks like this page wandered off into the digital wilderness...
      </p>

      <div className='inline-block px-4 py-2 rounded-full bg-muted text-muted-foreground text-sm font-medium mb-8'>
        Error code: 404
      </div>

      <Button asChild size='lg' className='rounded-full px-6'>
        <Link to='/' className='flex items-center gap-2'>
          <Home className='h-4 w-4' />
          <span>Take Me Home</span>
        </Link>
      </Button>
    </div>
  );
};
